import React from "react";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

export interface HeaderProps extends WithStyles<typeof styles> {}

const styles = createStyles({
  root: {
    flexGrow: 1
  },
  grow: {
    flexGrow: 1
  }
});

const Header = ({ classes }: HeaderProps) => (
  <div className={classes.root}>
    <header>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography variant="h6" color="inherit" className={classes.grow}>
            Figma FSM UI
          </Typography>
        </Toolbar>
      </AppBar>
    </header>
  </div>
);

export default withStyles(styles)(Header);
